import { render, staticRenderFns } from "./NewCustomerData.vue?vue&type=template&id=3d0901df&"
import script from "./NewCustomerData.vue?vue&type=script&lang=ts&"
export * from "./NewCustomerData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports